import {jsonMember, jsonObject} from "typedjson";

/**
 * Процесс BPM
 * WARNING: не все поля примаплены
 **/
@jsonObject
export class PitBpmProcessInstance {

  @jsonMember({constructor: Number, isRequired: true})
  id: number = null;

  @jsonMember({constructor: String, isRequired: true})
  code: string = null;

  @jsonMember({constructor: String, isRequired: true})
  name: string = null;

  /**
   * Id пользователя, запустившего инстанс БП.
   */
  @jsonMember({constructor: Number, isRequired: false})
  initiatorId: number = null;

  @jsonMember({constructor: String, isRequired: false})
  initiatorLogin: string = null;

  @jsonMember({constructor: String, isRequired: false})
  initiatorName: string = null;

  /**
   * Идентификатор бизнесс-сущности, по которой запущен инстанс БП.
   */
  @jsonMember({constructor: Number, isRequired: false})
  objectId: number = null;

  @jsonMember({constructor: String, isRequired: false})
  objectName: string = null;

  @jsonMember({constructor: Number, isRequired: false})
  objectTypeId: number = null;

  @jsonMember({constructor: Date, isRequired: false})
  startDateTime: Date = null;

  @jsonMember({constructor: Date, isRequired: false})
  finishDateTime: Date = null;
}
